import React, { useEffect, useState } from 'react'
import Constants from '../../../core/common/constant'
import api from '../../../infratructure/api'
import BannerCommon from '../../../infratructure/common/controls/banner'
import SearchFestival from '../../festival/search'
import PaginationCommon from '../../../infratructure/common/controls/pagination'
import LoadingFullPage from '../../../infratructure/common/controls/loading'
import MainLayout from '../../../infratructure/common/layout/main-layout'
import useTranslate from '../../../core/common/hook/useTranslate'
import { ROUTE_PATH } from '../../../core/common/appRouter'
import {
  showImageCommon,
  translationData
} from '../../../infratructure/utils/helper'
import FileUpload from './uploadFile'
import pdfImg from '../../../asset/img/icons/pdf.jpg'
import SearchPDF from '../common/search'
let timeout
const PDFMapPage = () => {
  const [listLeHoi, setListLeHoi] = useState([])
  const [listLeHoiFinal, setListLeHoiFinal] = useState([])

  const [loading, setLoading] = useState(false)
  const [searchText, setSearchText] = useState('')
  const [pagination, setPagination] = useState({})
  const [totalItem, setTotalItem] = useState()
  const [pageSize, setPageSize] = useState(Constants.PaginationConfigs.Size)
  const [changePage, setChangePage] = useState(1)

  const [startDate, setStartDate] = useState('')
  const [endDate, setEndDate] = useState('')

  const [dsQuanHuyen, setDsQuanHuyen] = useState([])
  const [qH, setQH] = useState('')

  const { translate } = useTranslate()

  const onGetListLeHoiAsync = async ({
    searchText = '',
    limit = pageSize,
    page = 1,
    qH = '',
    startDate = '',
    endDate = ''
  }) => {
    const response = await api.getAllBanDoPDF(``, setLoading)
    setListLeHoi(response.data.bandopdf)
    setListLeHoiFinal(response.data.bandopdf)

    // setPagination(response.data.pagination)
    // setTotalItem(response.data.totalItems)
  }

  const onGetQuanHuyenAsync = async () => {
    const response = await api.getAllQuanHuyen(``, setLoading)
    setDsQuanHuyen(response.data.quanHuyens)
  }

  const onSearch = async (
    searchText = '',
    limit = pageSize,
    page = 1,
    qH = '',
    startDate = '',
    endDate = ''
  ) => {
    onGetListLeHoiAsync({
      searchText: searchText,
      limit: limit,
      page: page,
      qH: qH,
      startDate: startDate,
      endDate: endDate
    })
  }
  useEffect(() => {
    onSearch().then(_ => {})
    onGetQuanHuyenAsync().then(_ => {})
  }, [])

  const onChangeSearchText = async e => {
    setSearchText(e.target.value)
    clearTimeout(timeout)
    timeout = setTimeout(() => {
      // onSearch(
      //   e.target.value,
      //   pageSize,
      //   changePage,
      //   qH,
      //   startDate,
      //   endDate
      // ).then(_ => {})
      const result = listLeHoi.filter(item =>
        String(item.tenbandopdf).toLowerCase().includes(e.target.value)
      )
      setListLeHoiFinal(result)
    }, Constants.DEBOUNCE_SEARCH)
  }
  const onChangeStartDate = async e => {
    setStartDate(e)
    if (endDate != '') {
      await onSearch(searchText, pageSize, changePage, qH, e, endDate).then(
        _ => {}
      )
    }
  }

  const onChangeEndDate = async e => {
    setEndDate(e)
    if (startDate != '') {
      await onSearch(searchText, pageSize, changePage, qH, startDate, e).then(
        _ => {}
      )
    }
  }

  const onChangeQH = e => {
    setQH(e)
    onSearch(searchText, pageSize, changePage, e, startDate, endDate).then(
      _ => {}
    )
  }

  const onPreviousPage = () => {
    setChangePage(changePage - 1)
    onSearch(searchText, pageSize, changePage - 1, qH, startDate, endDate).then(
      _ => {}
    )
  }

  const onNextPage = () => {
    setChangePage(changePage + 1)
    onSearch(searchText, pageSize, changePage + 1, qH, startDate, endDate).then(
      _ => {}
    )
  }

  return (
    <MainLayout className={'bg-white'}>
      <BannerCommon
        title={'festivalSlogan'}
        redirect={ROUTE_PATH.HOME_PAGE}
        redirectPage={'homePage'}
        currentPage={'pdfMap'}
      />
      <SearchPDF
        searchText={searchText}
        onChangeSearchText={onChangeSearchText}
      />
      {/* <FileUpload onSearch={onSearch} /> */}
      <section className='deals position-relative'>
        <div className='container position-absolute'>
          <div className='row'>
            <div className='col-lg-12'>
              <div className='common-title'>
                <div className='deal-icon'></div>
              </div>
            </div>
          </div>
        </div>

        <div className='container-fluid padding-common'>
          <div className='row'>
            {listLeHoiFinal.map((it, index) => (
              <div key={index} className='col-xl-3 col-lg-4 col-md-6 col-xs-12'>
                <div className='blog-content'>
                  <div className='blog-image'>
                    <a
                      href={`https://api.bandodulichdaknong.vn/api/public/${it.uribandopdf}`}
                      target='_blank'
                    >
                      <img src={pdfImg} alt='image' className='img-page' />
                    </a>
                  </div>
                  <div className='blog-info'>
                    <div className='blog-info'>
                      <div className='footer-info'>
                        <a
                          href={`https://api.bandodulichdaknong.vn/api/public/${it.uribandopdf}`}
                          target='_blank'
                          style={{
                            display: '-webkit-box',
                            WebkitBoxOrient: 'vertical',
                            WebkitLineClamp: 2,
                            overflow: 'hidden',
                            textOverflow: 'ellipsis'
                          }}
                          className='blog-title text-truncate-title-article'
                        >
                          {it.tenbandopdf}
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
            {/* <PaginationCommon
              changePage={changePage}
              onPreviousPage={onPreviousPage}
              onNextPage={onNextPage}
              pagination={pagination}
            /> */}
          </div>
        </div>
      </section>
      <LoadingFullPage loading={loading} />
    </MainLayout>
  )
}

export default PDFMapPage
